export enum FacetFilterType {
  contains = 'contains',
  startsWith = 'startsWith',
  endsWith = 'endsWith',
  equal = 'equal',
  and = 'and',
  between = 'between',
  greaterThan = 'greaterThan',
  lessThan = 'lessThan',
  greaterThanOrEqual = 'greaterThanOrEqual',
  lessThanOrEqual = 'lessThanOrEqual'
}
